import { Box, CircularProgress } from "@mui/material";

const Loader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        width: "100vw",
      }}
    >
      <CircularProgress size={"4rem"} color="info" />
    </Box>
  );
};

export default Loader;
